import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudySparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCloudySparkle"><Path d="M12.4 14H11.6L10.6 16.6L8 17.6V18.4L10.6 19.4L11.6 22H12.4L13.4 19.4L16 18.4V17.6L13.4 16.6L12.4 14Z" fill="currentColor"/><Path d="M6 18.9153C3.35615 17.7794 1.5 15.1109 1.5 12C1.5 7.85786 4.79071 4.5 8.85 4.5C11.8837 4.5 14.4881 6.37545 15.6105 9.05211C16.1263 8.87923 16.6775 8.78571 17.25 8.78571C20.1495 8.78571 22.5 11.1842 22.5 14.1429C22.5 16.8417 20.5442 19.0744 18 19.4457" stroke="currentColor"/></CentralIconBase>;
});

export default IconCloudySparkle;
